export class CpfHelper {

      public static AdicionarZerosEsquerda(cpfBase: number, cpfDigito: number){
        return CpfHelper.leftpad(cpfBase.toString(), 9) + CpfHelper.leftpad(cpfDigito.toString(), 2);
      }

        private static leftpad(valor: string, tamanho: number): string {
            return '0'.repeat(tamanho - valor.length) + valor; 
        }
}


// WEBPACK FOOTER //
// ./src/app/shared/helpers/cpf-helper.ts